import { API_AUTH } from "./common";

const InChoVayApi = {
  detail: ({ thuchiId }) =>
    API_AUTH.get(
      `quan-ly-thu-chi/thong-tin-phieu-thu-chi?thuchiId=${thuchiId}`,
      {}
    ),
  getInThuChi: ({ thuchiId, tenMauIn }) =>
    API_AUTH.get(
      `quan-ly-thu-chi/in-phieu-thu-chi?thuchiId=${thuchiId}&tenMauIn=${tenMauIn ? tenMauIn : ""
      }`,
      {}
    ),
};

export default InChoVayApi;
